import React, { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { useT } from "@/i18n";

const StickyCall = () => {
  const { t, lang } = useT();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="tel:5145941482"
      data-testid="sticky-call-button"
      className={`fixed bottom-6 right-6 z-50 inline-flex items-center gap-3 bg-[#ea7a1f] hover:bg-[#f08b34] text-white font-bold px-5 py-4 shadow-2xl pulse-ring transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <Phone className="w-5 h-5" strokeWidth={2.5} />
      <span className="hidden sm:inline tracking-wide text-sm">{t.sticky}</span>
      <span className="sm:hidden tracking-wide text-sm">{lang === "fr" ? "Appelez" : "Call Today"}</span>
    </a>
  );
};

export default StickyCall;
